/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useContext, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import SuiTypography from "components/SuiTypography";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";

import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import Switch from "@mui/material/Switch";
import toast from "react-hot-toast";

import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useForm, Controller } from "react-hook-form";
import { capitalCase } from "capital-case";

import { Empty } from "antd";

const ServiceSpecialty = ({ store, updateStore, editable = true, tree = [], sx = {} }) => {
  const [editVisible, setEditVisible] = useState(false);
  const [productTypes, setProductTypes] = useState({});
  const { register, handleSubmit, trigger, setValue, getValues, reset, errors, control } = useForm(
    {}
  );

  useEffect(() => {
    const originalProductTypes = store?.product_type_meta || [
      { product_type_id: "Bags", min_units: 100 },
    ];
    const temp = {};
    for (let i = 0; i < originalProductTypes.length; i++) {
      temp[originalProductTypes[i]["product_type_id"]] = originalProductTypes[i]["min_units"];
    }
    setProductTypes(temp);
  }, [store]);

  const handleSwitchChange = (pt) => {
    const temp = { ...productTypes };
    if (temp.hasOwnProperty(pt)) {
      delete temp[pt];
    } else {
      temp[pt] = 0;
    }
    setProductTypes(temp);
  };
  const productTypesOption = [];
  for (let i = 0; i < tree.length; i++) {
    for (let j = 0; j < tree[i]["children"].length; j++) {
      productTypesOption.push({
        label: tree[i]["children"][j]["label"],
        id: tree[i]["children"][j]["id"],
      });
    }
  }

  const handleShowEdit = (e) => {
    setEditVisible(true);
  };

  return (
    <Card sx={{ px: 2, minHeight: 300, ...sx }}>
      <div className="m-4">
        <div className="my-2  flex justify-between">
          <SuiTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            Our Specialities
          </SuiTypography>
        </div>
        {store?.metadata?.manufacturing_specialties ? (
          <div className="grid xsmall:grid-cols-1 small:grid-cols-2 medium:grid-cols-3 large:grid-cols-4 divide-y">
            {store.metadata.manufacturing_specialties.map((pt, index) => (
              <div key={index}>
                <SuiTypography variant="body1" fontWeight="regular">
                  {capitalCase(pt, { stripRegexp: /[^A-Z0-9\'\&\/-_]/gi })}
                </SuiTypography>
              </div>
            ))}
          </div>
        ) : (
          <SuiBox my={2} display="flex" alignItems="center" justifyContent="center" width="100%">
            <Empty />
          </SuiBox>
        )}
      </div>
    </Card>
  );
};

export default ServiceSpecialty;
